exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".content__2LaRJ{max-height:calc(100% - 56px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#fff;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1;flex:1}.contentExpandInPlace__3-jwC{height:auto;-webkit-box-flex:1;-ms-flex:1;flex:1}.contentHideAppBar__1i_nI{height:auto;max-height:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/app-content/styles.scss"],"names":[],"mappings":"AAEA,gBACE,6BACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,sBACA,gBACA,mBAAA,WAAA,MAAO,CACR,6BAGC,YACA,mBAAA,WAAA,MAAO,CACR,0BAGC,YACA,eAAgB,CACjB","file":"styles.scss","sourcesContent":["@import '../../variables';\n\n.content {\n  max-height: calc(100% - #{$appbar-height});\n  display: flex;\n  flex-direction: column;\n  background-color: $white;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.contentExpandInPlace {\n  height: auto;\n  flex: 1;\n}\n\n.contentHideAppBar {\n  height: auto;\n  max-height: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "content__2LaRJ",
	"contentExpandInPlace": "contentExpandInPlace__3-jwC",
	"contentHideAppBar": "contentHideAppBar__1i_nI"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/app-content/styles.scss
// module id = HmIr
// module chunks = 0